<template>
  <el-dialog
    width="766px"
    height="478px"
    :visible="tipDialog"
    @close="close"
    :title="tipTitle"
  >
    <img :src="tipUrl" alt="">
  </el-dialog>
</template>

<script>
import GlobalConfig from '@/global/config'
export default {
  name: 'SettingTipDialog',
  components: {},
  props: {
    tipDialog: {
      type: Boolean,
      require: true
    },
    tipName: String
  },
  data() {
    return {
      infoData: [
        {
          name: 'index',
          title: '指标',
          imgUrl: require('@/assets/img/index-stat/tip-index.png')
        },
        {
          name: 'area',
          title: '地区',
          imgUrl: require('@/assets/img/index-stat/tip-area.png')
        },
        {
          name: 'time',
          title: '时间',
          imgUrl: require('@/assets/img/index-stat/tip-time.png')
        },
        {
          name: 'cell',
          title: '单元格',
          imgUrl: ''
        }
      ]
    }
  },
  computed: {
    getSurveyId() {
      return GlobalConfig.getSurveyId()
    },
    tipTitle() {
      const curTipObj = this.infoData.find(item => item.name == this.tipName)
      return curTipObj.title
    },
    tipUrl() {
      const curTipObj = this.infoData.find(item => item.name == this.tipName)
      return curTipObj.imgUrl
    }
  },
  watch: {
  },
  created() {},
  mounted() {},
  methods: {
    close() {
      this.$emit('update:tipDialog', false)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog{
  border-radius: 4px;
}
::v-deep .el-dialog__header {
  background: #f5f7fa;
  padding: 12px 16px;
  border-radius: 4px;
  overflow: hidden;
}
::v-deep .el-dialog__headerbtn .el-dialog__close{
  font-size: 18px !important;
}
// 设置表单中间高度
::v-deep .el-form-item--small.el-form-item {
  margin-bottom: 0;
}
::v-deep .el-dialog__body {
  padding: 16px !important;
}
::v-deep .el-dialog__footer {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  padding: 16px 24px;
  .el-button {
    width: 88px;
    height: 32px;
  }

  .cancel {
    border: 1px solid #ccc;
    color: rgba(0, 0, 0, 0.45);
  }
}
</style>
